import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import PickOrderDetail from "@/views/OutboundManagement/PickOrderDetail.vue";

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  // {
  //   path: '/register',
  //   component: () => import('@/views/register'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  }, {
    path: '/manage',
    component: () => import('../views/Manage.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/Home'),
        // component: () => import('@/views/Home'),
        name: 'Home',
        meta: { title: '应用首页', icon: 'el-icon-menu', affix: true }
      },
      {
        path: '/pickOrder/detail', // 对应跳转的path（query参数方式）
        name: 'PickOrderDetail',
        component: PickOrderDetail,
        meta: { title: '拣货单详情' }, // 页面标题（可选）
        hidden: true
      },
      {
        path: '/specialRules/overLengthWeight',
        name: 'OverLengthWeight',
        component: () => import('@/views/LogisticsManagement/OverLengthWeight.vue'),
        meta: { title: '超长超重规则' },
        hidden: true
      },
      {
        path: '/system/role',
        name: 'Role',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理', icon: 'peoples' },
        hidden: true
      },
      {
        path: '/customer/email-send',
        name: 'EmailSend',
        component: () => import('@/views/CustomerManagement/EmailSend.vue'),
        meta: { title: '邮件发送', icon: 'el-icon-message' },
        hidden: true
      },
      {
        path: '/customer/email-view',
        name: 'EmailView',
        component: () => import('@/views/CustomerManagement/EmailView.vue'),
        meta: { title: '邮件查看', icon: 'el-icon-view' },
        hidden: true
      },
      {
        path: '/user/profile/:activeTab?',
        name: 'Profile',
        component: () => import('@/views/system/user/profile/index.vue'),
        meta: { title: '个人中心', icon: 'user' },
        hidden: true
      }
      // ,
      // {
      //   path: '/products/edit',
      //   component: () => import('@/views/Product/Createproduct'),
      //   name: 'editProduct',
      //   hidden: true
      // },
      // {
      //   path: '/products/copy',
      //   component: () => import('@/views/Product/Createproduct'),
      //   name: 'copyProduct',
      //   hidden: true
      // }
    ]
  },


]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/system/theme',
    component: Layout,
    hidden: true,
    permissions: ['system:theme:edit'],
    children: [
      {
        path: '',
        component: () => import('@/views/system/theme/index'),
        name: 'SystemThemeSettings',
        meta: { title: '系统主题设置', icon: 'el-icon-brush' }
      }
    ]
  }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

